import { NavRoute } from '@web-app/components/Navbar/types';
import { PRESCRIPTION_TASKS_ROUTE } from '@web-app/constants/routes';
import {
  LuCalendarClock,
  LuCalendarDays,
  LuLibrary,
  LuListChecks,
  LuMail,
  LuMessageSquare,
  LuSettings,
  LuShieldCheck,
  LuUserCheck,
  LuUsers,
  LuWallet,
} from 'react-icons/lu';

export const APPOINTMENT_ROUTE = '/';
export const CALENDAR_ROUTE = '/calendar';
export const TASKS_ROUTE = '/appointments/tasks';
export const SUPERVISION_TASKS_ROUTE = '/appointments/supervision-tasks';
export const MANAGE_PRACTICE_ROUTE = '/manage-practice';
export const FOLLOW_UPS_ROUTE = '/follow-ups';
export const PERFORMANCE_ROUTE = '/performance/insights';
export const PATIENTS_ROUTE = '/patients';
export const BENEFIT_CHECK_REQUEST_ROUTE = '/benefit-check-request';
export const PRESCRIPTION_REVIEW_ROUTE = '/prescription-review';
export const ACCESS_NP_REVIEW_ROUTE = '/access-np-review';
/**
 * `?enrollment=<id>` on ACCESS_NP_REVIEW_ROUTE opens that Care Update's review
 * drawer, so a link (the ACCESS deadline alerts, BSE-3942) can land on one
 * patient.
 */
export const ACCESS_NP_REVIEW_ENROLLMENT_PARAM = 'enrollment';
export { PRESCRIPTION_TASKS_ROUTE } from '@web-app/constants/routes';
export const INTERNAL_TOOLS_ROUTE = '/internal-tools';
export const SETTINGS_ROUTE = '/settings';
export const PAYMENTS_ROUTE = '/payments';
export const W9_MANAGEMENT_ROUTE = '/w9-management';
export const INTRO_VIDEO_ROUTE = '/intro-video';
export const IN_SESSION_TEMPLATES_ROUTE = '/in-session-templates';
export const DOCUMENTS_ROUTE = '/documents';
export const GROUP_PRACTICE_ROUTE = '/group-practice';
export const GROUP_PRACTICE_PAYER_ELIGIBILITY_ROUTE =
  '/group-practice-payer-eligibility';
export const MESSAGES_ROUTE = '/messages';
export const SUPPORT_CONCIERGE_ROUTE = '/support-concierge';
export const CANCELLATION_FEES_ROUTE = '/cancellation-fees';
export const INVOICE_REVIEW_ROUTE = '/invoice-review';
export const NON_APPOINTMENT_HOURS_ROUTE = '/non-appointment-hours';
// Synthetic parent paths — these don't navigate, they only group children
// into collapsible navbar sections.
export const RESOURCES_GROUP_ROUTE = '/resources';
export const FINANCES_GROUP_ROUTE = '/finances';

export const NAVBAR_ROUTES: NavRoute[] = [
  {
    path: APPOINTMENT_ROUTE,
    name: 'Appointments',
    icon: <LuCalendarDays />,
  },
  {
    path: CALENDAR_ROUTE,
    name: 'Calendar',
    icon: <LuCalendarClock />,
  },
  {
    path: TASKS_ROUTE,
    name: 'Tasks',
    icon: <LuListChecks />,
  },
  {
    path: MESSAGES_ROUTE,
    name: 'Messages',
    icon: <LuMessageSquare />,
  },
  {
    path: SUPPORT_CONCIERGE_ROUTE,
    name: 'Support Concierge',
    icon: <LuMail />,
    featureOwned: true,
  },
  {
    path: SUPERVISION_TASKS_ROUTE,
    name: 'Supervision Tasks',
    icon: <LuUserCheck />,
  },
  {
    path: PATIENTS_ROUTE,
    name: 'Patients',
    icon: <LuUsers />,
    children: [
      {
        path: PATIENTS_ROUTE,
        name: 'Overview',
      },
      {
        path: BENEFIT_CHECK_REQUEST_ROUTE,
        name: 'Benefit Check Request',
      },
      {
        path: PRESCRIPTION_REVIEW_ROUTE,
        name: 'Prescription Review',
      },
      {
        path: PRESCRIPTION_TASKS_ROUTE,
        name: 'Prescription Tasks',
      },
      {
        path: ACCESS_NP_REVIEW_ROUTE,
        name: 'Care Updates',
      },
    ],
  },
  {
    // doesn't redirect to the route, displays a collapsible menu
    path: MANAGE_PRACTICE_ROUTE,
    name: 'Manage Practice',
    icon: <LuShieldCheck />,
    children: [
      {
        path: MANAGE_PRACTICE_ROUTE,
        name: 'Overview',
      },
      {
        path: FOLLOW_UPS_ROUTE,
        name: 'Scheduling Assistant',
      },
      {
        path: PERFORMANCE_ROUTE,
        name: 'Practice Insights',
      },
      {
        path: W9_MANAGEMENT_ROUTE,
        name: 'W-9 Management',
      },
    ],
  },
  {
    // doesn't redirect to the route, displays a collapsible menu
    path: RESOURCES_GROUP_ROUTE,
    name: 'Resources',
    icon: <LuLibrary />,
    children: [
      {
        path: INTRO_VIDEO_ROUTE,
        name: 'Intro Video',
      },
      {
        path: IN_SESSION_TEMPLATES_ROUTE,
        name: 'In-Session Templates',
      },
      {
        path: DOCUMENTS_ROUTE,
        name: 'Documents',
      },
    ],
  },
  {
    // doesn't redirect to the route, displays a collapsible menu
    path: FINANCES_GROUP_ROUTE,
    name: 'Finances',
    icon: <LuWallet />,
    children: [
      {
        path: CANCELLATION_FEES_ROUTE,
        name: 'Fee Decisions',
      },
      {
        path: PAYMENTS_ROUTE,
        name: 'Payments',
      },
      {
        path: NON_APPOINTMENT_HOURS_ROUTE,
        name: 'Non-Appointment Hrs',
      },
      {
        path: INVOICE_REVIEW_ROUTE,
        name: 'Invoice Review',
      },
      {
        path: GROUP_PRACTICE_ROUTE,
        name: 'Payments',
      },
      {
        path: GROUP_PRACTICE_PAYER_ELIGIBILITY_ROUTE,
        name: 'Payer Eligibility',
      },
    ],
  },
  {
    path: SETTINGS_ROUTE,
    name: 'Settings',
    icon: <LuSettings />,
  },
  {
    path: INTERNAL_TOOLS_ROUTE,
    name: 'Internal Tools',
    icon: <LuSettings />,
  },
];

export const MENU_WIDTH = 285;
